module.exports = __webpack_public_path__ + "front/img/p5.66e6c6a2.png";